<template>
  <b-modal
    :id="modalId"
    modal-class="modal-style function-modal"
    ref="modal"
    v-model="showModal"
  >
    <button class="modal-close-btn" @click="handleHideModal">
      <img src="~@/assets/img/svg/icn_close.svg" alt="" />
    </button>
    <div class="product-info">
      <div class="product-info__img">
        <img :src="program.avatar" alt="" />
      </div>

      <div class="product-info__detail">
        <div class="product-info__detail-name">
          {{ program.name }}
        </div>

        <div class="product-info__detail-price">$ {{ program.price }}</div>
      </div>
    </div>

    <div class="member-benefit">
      <div class="giveaway__title">使用會員{{ level.name }}</div>
      <div
        class="switch"
        @click="toggleSwitchBenefit"
        :class="{ on: useBenefit }"
      >
        <div class="btn"></div>
      </div>
    </div>

    <div class="more-offers">
      <div class="more-offers__text-row">
        <div class="more-offers__title">
          更多優惠
        </div>
        <div class="more-offers__alert">
          優惠內容僅能三選一折抵
        </div>

        <button
          class="more-btn more-offer-btn"
          :class="offerShowMore ? 'active' : ''"
          @click="offerShowMore = !offerShowMore"
        >
          {{ showOfferText }}
          <div class="icon-arrow_d"></div>
        </button>
      </div>

      <b-collapse v-model="offerShowMore" class="more-offers__collapse">
        <div class="collapse-in">
          <div class="single-input-field">
            <p class="input-title">折扣(折)</p>

            <div class="custom-input">
              <input
                type="text"
                placeholder="如9折輸入9 , 85折輸入85"
                autocomplete="off"
                class="custom-text"
                v-model="percentageDiscountAmount"
              />
              <div class="unit">折</div>
            </div>
          </div>

          <div class="single-input-field">
            <p class="input-title">折價(元)</p>

            <div class="custom-input">
              <input
                type="text"
                placeholder="請輸入折抵價格"
                autocomplete="off"
                class="custom-text"
                v-model="priceDiscountAmount"
              />
              <div class="unit">元</div>
            </div>
          </div>

          <div class="giveaway">
            <div class="giveaway__title">
              是否設為贈品
            </div>
            <div
              class="switch"
              @click="toggleSwitch"
              :class="{ on: isGiveaway }"
            >
              <div class="btn"></div>
            </div>
          </div>
        </div>
      </b-collapse>

      <!-- <div class="amount">
        <div class="amount__title">
          數量
        </div>

        <div class="count-area">
          <a href="#" @click.prevent="handleMinus">
            <span class="icon-icon_less"></span>
          </a>
          <div title="1" class="quantity">{{ currentQuantity }}</div>
          <a href="#" @click.prevent="handlePlus">
            <span class="icon-icon_add"></span>
          </a>
        </div>
      </div> -->
    </div>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="addToCart">
        <!-- @click="$bvModal.hide(`program-modal${id}`)" -->

        {{ updateAction === true ? '更新購物車' : '加入購物車' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  props: {
    program: {
      type: Object,
      required: true
    },
    level: {
      type: Object,
      default() {
        return {
          name: '一般',
          discount_percentage: 1
        };
      }
    },
    id: {
      type: String,
      default() {
        return 'purchase-product';
      }
    },
    push: {
      type: Boolean,
      default() {
        return false;
      }
    },
    //在購物車裡的index
    programIndex: {
      type: Number,
      required: false
    }
  },
  computed: {
    updateAction() {
      return this.programIndex >= 0;
    },
    modalId() {
      return `program-modal-${this.id}`;
    },
    programParams() {
      return Object.assign(cloneDeep(this.program), {
        in_cart: true,
        count: this.currentQuantity,
        discount_type: this.discountType,
        discount_number: this.discountNumber
      });
    },
    discountNumber: {
      get() {
        switch (this.discountType) {
          case '1':
            return this.program.price;

          case '2':
            return this.percentageDiscountAmount;

          case '3':
            return this.priceDiscountAmount;

          case '4':
            return 100 - this.level.discount_percentage * 100;

          default:
            return 0;
        }
      },

      set(value) {
        switch (this.discountType) {
          case '1':
            this.isGiveaway = true;
            break;

          case '2':
            this.percentageDiscountAmount = value;
            break;

          case '3':
            this.priceDiscountAmount = value;
            break;

          case '4':
            this.useBenefit = true;
            break;

          default:
            break;
        }
      }
    },
    showOfferText() {
      if (this.offerShowMore) {
        return '收合優惠';
      }

      return '展開優惠';
    }
  },
  data() {
    return {
      discountShowMore: false,
      offerShowMore: false,
      color: [],
      isGiveaway: false,
      currentQuantity: 1,
      useBenefit: false,
      showModal: false,
      percentageDiscountAmount: null,
      priceDiscountAmount: null,
      discountType: '0'
    };
  },
  watch: {
    showModal() {
      if (this.showModal == false) {
        this.reset();
      } else {
        this.offerShowMore = this.push === false ? this.program.in_cart : false;
        this.currentQuantity = this.push === false ? this.program.count : 1;
        this.discountType =
          this.push === false ? this.program.discount_type : '0';
        this.discountNumber =
          this.push === false
            ? this.program.discount_number
            : this.discountNumber;
      }
    },
    useBenefit(next) {
      if (next == true) {
        this.useMmeberDiscount();
      }
    },
    isGiveaway(next) {
      if (next == true) {
        this.useGiveawayDiscount();
      }
    },
    percentageDiscountAmount(next) {
      if (next < 0 || next > 100) {
        alert('輸入折扣有誤,折扣範圍 0 ~ 100');
        this.percentageDiscountAmount = null;
      }

      if (next != null && next != '') {
        this.usePercentageDiscount();
      }
    },
    priceDiscountAmount(next) {
      if (next < 0 || next > this.program.price * this.currentQuantity) {
        alert(
          '輸入折價有誤,折價範圍 0 ~ ' +
            this.program.price * this.currentQuantity
        );
        this.priceDiscountAmount = null;
      }

      if (next != null && next != '') {
        this.usePriceDiscount();
      }
    }
  },
  methods: {
    ...mapActions('order', ['addProgram', 'updateProgram']),
    toggleSwitch() {
      this.isGiveaway = !this.isGiveaway;
    },
    toggleSwitchBenefit() {
      this.useBenefit = !this.useBenefit;
    },
    // handlePlus() {
    //   this.currentQuantity = this.currentQuantity + 1;
    // },
    // handleMinus() {
    //   let count = this.currentQuantity - 1;
    //   count <= 0 ? (this.currentQuantity = 1) : (this.currentQuantity = count);
    // },
    handleHideModal() {
      this.$refs.modal.hide();
    },
    reset() {
      this.discountShowMore = false;
      this.offerShowMore = false;
      this.isGiveaway = false;
      this.currentQuantity = 1;
      this.useBenefit = false;
      this.discountType = '0';
      this.percentageDiscountAmount = null;
      this.priceDiscountAmount = null;
    },
    addToCart() {
      // 加入/更新購物車後才判斷優惠內容
      this.chooseDiscount();

      if (this.updateAction) {
        this.updateProgram({
          program: this.programParams,
          programIndex: this.programIndex
        });
      } else {
        this.addProgram({ program: this.programParams, push: this.push });
      }

      this.closeModal();
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    useMmeberDiscount() {
      this.discountType = '4';
      this.percentageDiscountAmount = null;
      this.priceDiscountAmount = null;
      this.isGiveaway = false;
    },
    usePercentageDiscount() {
      this.discountType = '2';
      this.priceDiscountAmount = null;
      this.isGiveaway = false;
      this.useBenefit = false;
    },
    usePriceDiscount() {
      this.discountType = '3';
      this.percentageDiscountAmount = null;
      this.isGiveaway = false;
      this.useBenefit = false;
    },
    useGiveawayDiscount() {
      this.discountType = '1';
      this.percentageDiscountAmount = null;
      this.priceDiscountAmount = null;
      this.useBenefit = false;
    },
    chooseDiscount() {
      if (this.isGiveaway === true) {
        this.discountType = '1';
      } else if (
        this.percentageDiscountAmount != null &&
        this.percentageDiscountAmount != ''
      ) {
        this.discountType = '2';
      } else if (
        this.priceDiscountAmount != null &&
        this.priceDiscountAmount != ''
      ) {
        this.discountType = '3';
      } else if (this.useBenefit === true) {
        this.discountType = '4';
      } else {
        this.discountType = '0';
      }
    }
  }
};
</script>
